// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"56":"63a427af","57":"c8131bfd","124":"86079ae3","353":"1b95c31e","449":"7f2dcac2","453":"703d9625","465":"d0630ac0","660":"5e667519","697":"7dcc9f2d","712":"37cefd7c"}[chunkId] + ".chunk.js";
};